import { createContext, useContext, useState, useEffect } from "react";
import { AppContext } from "./AppProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export const AuthContext = createContext({
  user: null,
  setUser: () => {},
  token: null,
  setToken: () => {},
  isLoggedIn: () => {},
  getToken: () => {},
  signin: async () => {},
  signout: async () => {},
  getFullName: () => {},
});

export function AuthProvider({ children }) {
  const appContext = useContext(AppContext);


  // Initialize user and token from sessionStorage
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(() => sessionStorage.getItem("token") || null);

  // Sincroniza usuario y token con sessionStorage
  useEffect(() => {
    if (user) {
      sessionStorage.setItem("user", JSON.stringify(user));
    } else {
      sessionStorage.removeItem("user");
    }
  }, [user]);

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("token", token);
    } else {
      sessionStorage.removeItem("token");
    }
  }, [token]);

  const isLoggedIn = () => !!token;

  const getToken = () => token;

  const getFullName = () => user?.user;

  const signin = async (email, password) => {
    const response = await fetch('/api/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      setUser(data);
      setToken(data.token);
    } else {
      appContext.showMessage(
        "There was an error logging you in",
        "error"
      );
    }
    return response.ok;
  };

  const signout = (cb) => {
    if (!token) {
      setUser(null);
      setToken(null);
      if (cb) cb();
      return;
    }
    const headers = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      }
    }
    return fetch('/api/logout', headers)
      .finally(() => {
        setUser(null);
        setToken(null);
        if (cb) cb();
      });
  };



  const providedValue = {
    user,
    setUser,
    token,
    setToken,
    isLoggedIn,
    getToken,
    getFullName,
    signin,
    signout,
  };

  return <AuthContext.Provider value={providedValue}>{children}</AuthContext.Provider>;
}